<article class="rounded-md border border-border p-4 pb-2 bg-accent">
    <h3 class="text-sm font-semibold text-foreground">Draft today</h3>
    <dl class="mt-3 divide-y divide-border">
        @for (row of rows(); track row.label) {
            <div class="flex items-center gap-3 py-2.5 text-sm">
                <ng-icon
                    qpx
                    context="secondary"
                    name="lucideCheckCircle2"
                    size="sm"
                    [strokeWidth]="2.5"
                />
                <dt class="text-xs grow text-secondary font-semibold">
                    {{ row.label }}
                </dt>
                <dd class="text-xs text-right text-secondary font-medium">
                    {{ row.draft }}
                </dd>
            </div>
        }
    </dl>
</article>

<div
    class="mx-auto hidden h-10 w-10 items-center justify-center rounded-full bg-accent md:flex"
    aria-hidden="true"
>
    <ng-icon
        qpx
        context="secondary"
        name="lucideArrowRight"
        [strokeWidth]="2.5"
    />
</div>

<article
    class="rounded-md border border-success-muted p-4 pb-2 bg-success-muted/30"
>
    <div class="flex items-center justify-between gap-3">
        <h3 class="text-sm font-semibold text-success-decorative">
            Published includes
        </h3>
        <div class="inline-flex h-5 items-center">
            <span
                class="rounded-md bg-success-muted px-2 py-1 text-xs font-semibold text-success-decorative"
            >
                Full operational access
            </span>
        </div>
    </div>
    <dl class="mt-3 divide-y divide-success-muted">
        @for (row of rows(); track row.label) {
            <div class="flex items-center gap-3 py-2.5 text-sm">
                <ng-icon
                    qpx
                    context="success"
                    name="lucideCheckCircle2"
                    size="sm"
                    [strokeWidth]="2.5"
                />
                <dt class="text-xs grow text-success-decorative font-semibold">
                    {{ row.label }}
                </dt>
                <dd class="text-xs text-right text-secondary font-medium">
                    {{ row.published }}
                </dd>
            </div>
        }
    </dl>
</article>
